// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-E":"E_power-ocean-collection-E__N_7nm"};